// message types
export const MESSAGE_IMAGE = "image";
export const MESSAGE_APPLICATION = "application";
export const MESSAGE_AUDIO = "audio";
export const MESSAGE_URL = "url";
export const MESSAGE_QUOTED = "quote";
export const MESSAGE_LOCATION = "location";
export const MESSAGE_NOTIFICATION = "notification";
export const MESSAGE_TEXT = "MESSAGE_TEXT";
export const MESSAGE_CUSTOM_OFFER = "custom-offer";
export const MESSAGE_GIVE_FEEDBACK = "feedback";
export const MESSAGE_MEET = "meet";
export const MESSAGE_POLL = "poll";
export const MESSAGE_FORM = "form";
export const MESSAGE_CREDENTIAL_REQUEST = "cred-request";
export const MESSAGE_QUEST = "quest";
export const MESSAGE_RECOMMENDED_MENTORS = "recommendedMentor";
export const MESSAGE_RECOMMENDED_GIGS = "recommendedGig";
export const MESSAGE_RECOMMENDED_PROGRAM = "recommendedProgram";
export const MESSAGE_CALL_SUMMARY = "call-summary";
export const MESSAGE_EMAIL_SUMMARY = "email-summary";
export const MESSAGE_APPOINTMENT_SUMMARY = "appointment-summary";
export const MESSAGE_EMPLOYEE_CONTACT = "employee-contact";
// Retired 22 Oct 2026 with the Pro-plan eligibility flow. Kept only so old
// messages that carry this attachment are recognised and render nothing.
export const MESSAGE_PRO_PLAN_ELIGIBILITY = "pro-plan-eligibility";
export const MESSAGE_CONSULTATION = "consultation";
export const MESSAGE_SERVICE_PRICING = "service-pricing";
export const MESSAGE_ARTIFACT = "artifact";
export const MESSAGE_RETRY_NOTIFICATION = "retry-notification";
export const MESSAGE_LIVE_CALL_CTA = "live-call-cta";
// "Keep talking with us" — sent when a student phoned us with no call minutes
// left: live coaching session or talk-time, each opening a preloaded cart. Key
// shared with the server's `CALL_SUPPORT_OFFER_ATTACHMENT_KEY`.
export const MESSAGE_CALL_SUPPORT_OFFER = "call-support-offer";
// "Your letter needs details" — a provider set up a Letter of Recommendation
// for the applicant. Key shared with the server's `LOR_LETTER_ATTACHMENT_KEY`.
export const MESSAGE_LOR_LETTER = "lor-letter";

// Action Types
export const CREATE_ROOM = "CREATE_ROOM";
export const JOIN_ROOM = "JOIN_ROOM";

export const SET_USERNAME = "SET_USERNAME";
export const SET_CONVERSATIONS = "SET_CONVERSATIONS";
export const APPEND_CONVERSATIONS = "APPEND_CONVERSATIONS";
export const SET_CONVERSATION_PAGINATION = "SET_CONVERSATION_PAGINATION";

export const SET_TYPING_DATA = "SET_TYPING_DATA";
export const SEND_MESSAGE_SEEN = "SEND_MESSAGE_SEEN";
export const SET_SYSTEM_MESSAGE_SEEN_DATA = "SET_SYSTEM_MESSAGE_SEEN_DATA";

export const SET_CURRENT_ROOM = "SET_CURRENT_ROOM";
export const SET_CURRENT_ROOM_MESSAGES = "SET_CURRENT_ROOM_MESSAGES";
export const UPDATE_CURRENT_ROOM_MESSAGES = "UPDATE_CURRENT_ROOM_MESSAGES";
export const UPDATE_CURRENT_ROOM_HISTORY = "UPDATE_CURRENT_ROOM_HISTORY";

export const SET_PARTICIPANTS_DETAILS = "SET_PARTICIPANTS_DETAILS";
export const SET_PARTICIPANTS_COUNT = "SET_PARTICIPANTS_COUNT";
export const UPDATE_CONVERSATION = "UPDATE_CONVERSATION";

export const MESSAGES_LOADING = "MESSAGES_LOADING";
export const ALL_MESSAGES_ARE_LOADED = "ALL_MESSAGES_ARE_LOADED";

export const SET_CONVERSATION_TOPICS = "SET_CONVERSATION_TOPICS";
export const UPDATE_CONVERSATION_TOPIC = "UPDATE_CONVERSATION_TOPIC";
export const UPDATE_CONVERSATION_TOPICS = "UPDATE_CONVERSATION_TOPICS";
export const SET_CURRENT_TOPIC = "SET_CURRENT_TOPIC";
export const CONVERSATION_TOPICS_LOADING = "CONVERSATION_TOPICS_LOADING";

export const UPDATE_CONVERSATION_LAST_ACTIVITY =
  "UPDATE_CONVERSATION_LAST_ACTIVITY";

export const UPDATE_CONVERSATIONS_LIST = "UPDATE_CONVERSATIONS_LIST";
export const REMOVE_CONVERSATION_FROM_LIST = "REMOVE_CONVERSATION_FROM_LIST";

export const ADD_TO_SEND_MESSAGE_QUEUE = "ADD_TO_SEND_MESSAGE_QUEUE";
export const REMOVE_FROM_SEND_MESSAGE_QUEUE = "REMOVE_FROM_SEND_MESSAGE_QUEUE";

// User Presence
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const USER_ONLINE = "USER_ONLINE";

// Automation Status
export const SET_AUTOMATION_STATUS = "SET_AUTOMATION_STATUS";
export const SET_OPS_AGENT_PAUSED = "SET_OPS_AGENT_PAUSED";

// Conversation Filter
export const SET_CONVERSATION_FILTER = "SET_CONVERSATION_FILTER";

// Meet Permissions
export const UPDATE_USER_PERMISSIONS = "UPDATE_USER_PERMISSIONS";
export const UPDATE_LAST_SEEN = "UPDATE_LAST_SEEN";

export const TOGGLE_CONVERSATION_INFO_PANEL = "TOGGLE_CONVERSATION_INFO_PANEL";
export const CONVERSATION_HISTORY_FAILED = "CONVERSATION_HISTORY_FAILED";
export const CLEAR_CONVERSATION_HISTORY_ERROR =
  "CLEAR_CONVERSATION_HISTORY_ERROR";

// URL Conversation Loading
export const SET_URL_CONVERSATION_LOADING = "SET_URL_CONVERSATION_LOADING";
export const SET_URL_CONVERSATION_ERROR = "SET_URL_CONVERSATION_ERROR";

// Mail Inbox
export const SET_MAIL_MESSAGES = "SET_MAIL_MESSAGES";
export const UPDATE_MAIL_HISTORY = "UPDATE_MAIL_HISTORY";
export const ALL_MAIL_MESSAGES_LOADED = "ALL_MAIL_MESSAGES_LOADED";
